import jwt_decode from "jwt-decode";
import { clearTokenCache } from "@helper/interceptor";

export const actionTypes = {
  Login: "[Login] Action",
  Logout: "[Logout] Action",
  UserRequested: "[Request User] Action",
  UserLoaded: "[Load User] Auth API",
  refreshToken: "[Load refreshToken] Auth API",
  refreshExp: "[Load refreshExp] Auth API",
  SetUser: "[Set User] Action",
  UpdateUserLanguage: "[Update User Language] Action",
  UpdateUserAccountType: "[Update User Account Type] Action",
  UpdateMoistureContentDisplayMode: "[Update Moisture Content Display Mode] Action",
  UpdateMoistureContentCapEnabled: "[Update Moisture Content Cap Enabled] Action",
};

const initialAuthState = {
  authToken: undefined,
  refreshExp: undefined,
  user: undefined,
};

const normalizeUserPayload = (user = {}, prevUser = {}) => {
  const merged = { ...prevUser, ...user };
  if (merged.user_id == null && merged.id != null) {
    merged.user_id = merged.id;
  }
  return merged;
};

export const authReducer = (state = initialAuthState, action) => {
  switch (action.type) {
    case actionTypes.Login: {
      const { authToken } = action.payload;
      const user = jwt_decode(authToken);
      return { ...state, authToken, user: normalizeUserPayload(user, state.user) };
    }
    case actionTypes.refreshToken: {
      const { refreshToken } = action.payload;
      return { ...state, refreshToken };
    }
    case actionTypes.refreshExp: {
      const { refreshExp } = action.payload;
      return { ...state, refreshExp: refreshExp };
    }
    case actionTypes.UserLoaded: {
      return { ...state, user: normalizeUserPayload(action.payload.user, state.user) };
    }
    case actionTypes.SetUser: {
      return { ...state, user: normalizeUserPayload(action.payload.user, state.user) };
    }
    case actionTypes.UpdateUserLanguage: {
      return {
        ...state,
        user: {
          ...state.user,
          language: action.payload.language,
        },
      };
    }
    case actionTypes.UpdateUserAccountType: {
      return {
        ...state,
        user: {
          ...state.user,
          account_type: action.payload.account_type,
        },
      };
    }
    case actionTypes.UpdateMoistureContentDisplayMode: {
      const mode = action.payload.moisture_content_display_mode;
      return {
        ...state,
        user: {
          ...state.user,
          moisture_content_display_mode: mode,
          ...(state.user?.profile
            ? {
                profile: {
                  ...state.user.profile,
                  moisture_content_display_mode: mode,
                },
              }
            : {}),
        },
      };
    }
    case actionTypes.UpdateMoistureContentCapEnabled: {
      const cap = action.payload.moisture_content_cap_enabled;
      return {
        ...state,
        user: {
          ...state.user,
          moisture_content_cap_enabled: cap,
          ...(state.user?.profile
            ? {
                profile: {
                  ...state.user.profile,
                  moisture_content_cap_enabled: cap,
                },
              }
            : {}),
        },
      };
    }
    case actionTypes.Logout: {
      // Clear token cache when logging out
      clearTokenCache();
      return initialAuthState;
    }
    default:
      return state;
  }
};
export const actions = {
  login: (authToken) => ({ type: actionTypes.Login, payload: { authToken } }),
  refreshToken: (refreshToken) => ({ type: actionTypes.refreshToken, payload: { refreshToken } }),
  refreshExp: (refreshExp) => ({ type: actionTypes.refreshExp, payload: { refreshExp } }),
  logout: () => ({ type: actionTypes.Logout }),
  userLoaded: (user) => ({ type: actionTypes.UserLoaded, payload: { user } }),
  setUser: (user) => ({ type: actionTypes.SetUser, payload: { user } }),
  updateUserLanguage: (language) => ({
    type: actionTypes.UpdateUserLanguage,
    payload: { language },
  }),
  updateUserAccountType: (account_type) => ({
    type: actionTypes.UpdateUserAccountType,
    payload: { account_type },
  }),
  updateMoistureContentDisplayMode: (moisture_content_display_mode) => ({
    type: actionTypes.UpdateMoistureContentDisplayMode,
    payload: { moisture_content_display_mode },
  }),
  updateMoistureContentCapEnabled: (moisture_content_cap_enabled) => ({
    type: actionTypes.UpdateMoistureContentCapEnabled,
    payload: { moisture_content_cap_enabled },
  }),
};
